import React, { memo } from 'react'
import { Row, Col } from 'react-bootstrap'

const SchedulingMetaPanel = memo(
  ({
    coachClientName,
    duration,
    totalSessions,
    firstSlotDuration,
    otherSlotsDuration,
    hasGrowthInRemaining,
    schedulingType,
    sowType,
  }) => {
    // Keep in sync with app/client CoachDetailsSection duration logic
    const getDurationLines = () => {
      // QUEST SOWs: Growth + Wisdom sessions
      if (sowType === 'QUEST') {
        if (firstSlotDuration && otherSlotsDuration) {
          return [
            `Growth Session: ${firstSlotDuration} Minutes`,
            `Wisdom Session: ${otherSlotsDuration} Minutes`,
          ]
        }
        return [`${duration || otherSlotsDuration} Minutes`]
      }

      // First-session flow schedules only one session: growth if present, else coaching
      if (schedulingType === 'first-session') {
        if (hasGrowthInRemaining && firstSlotDuration) {
          return [`Growth Session: ${firstSlotDuration} Minutes`]
        }
        if (otherSlotsDuration) {
          return [`Coaching Session: ${otherSlotsDuration} Minutes`]
        }
      }

      // Other flows: if growth is still remaining show both, otherwise coaching only
      if (hasGrowthInRemaining && firstSlotDuration && otherSlotsDuration) {
        return [
          `Growth Session: ${firstSlotDuration} Minutes`,
          `Coaching Session: ${otherSlotsDuration} Minutes`,
        ]
      }

      if (otherSlotsDuration) {
        return [`Coaching Session: ${otherSlotsDuration} Minutes`]
      }

      return [`${duration} Minutes`]
    }

    const durationLines = getDurationLines()

    return (
      <Row className='scheduling-meta-panel'>
        <Col xs={12} md className='scheduling-meta-panel__item'>
          <h3 className='my-auto s3'>Coach & Client Name</h3>
          <p className='s6 text-muted mt-2 mb-0'>{coachClientName}</p>
        </Col>
        <Col xs={12} md className='scheduling-meta-panel__item'>
          <h3 className='my-auto s3'>Duration</h3>
          <p className='s6 text-muted mt-2 mb-0'>
            {durationLines.map((line, index) => (
              <React.Fragment key={line}>
                {index > 0 && <br />}
                {line}
              </React.Fragment>
            ))}
          </p>
        </Col>
        {sowType !== 'QUEST' && (
          <Col xs={12} md className='scheduling-meta-panel__item'>
            <h3 className='my-auto s3'>No. of Sessions</h3>
            <p className='s6 text-muted mt-2 mb-0'>{totalSessions}</p>
          </Col>
        )}
      </Row>
    )
  },
)

SchedulingMetaPanel.displayName = 'SchedulingMetaPanel'

export default SchedulingMetaPanel
